// Decorative henna / paisley line-art SVG motifs.

export const Mandala = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 200 200"
    fill="none"
    stroke="currentColor"
    strokeWidth="0.6"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <circle cx="100" cy="100" r="92" strokeOpacity="0.5" />
    <circle cx="100" cy="100" r="72" strokeOpacity="0.4" />
    <circle cx="100" cy="100" r="40" strokeOpacity="0.6" />
    {Array.from({ length: 24 }).map((_, i) => {
      const a = (i * 360) / 24;
      return (
        <g key={i} transform={`rotate(${a} 100 100)`}>
          <path
            d="M100 8 C112 30 112 50 100 62 C88 50 88 30 100 8 Z"
            strokeOpacity="0.55"
          />
          <circle cx="100" cy="70" r="2.2" strokeOpacity="0.7" />
        </g>
      );
    })}
    {Array.from({ length: 12 }).map((_, i) => {
      const a = (i * 360) / 12;
      return (
        <path
          key={`p-${i}`}
          transform={`rotate(${a} 100 100)`}
          d="M100 40 C118 55 118 82 100 96 C82 82 82 55 100 40 Z"
          strokeOpacity="0.5"
        />
      );
    })}
  </svg>
);

export const Paisley = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 120 160"
    fill="none"
    stroke="currentColor"
    strokeWidth="0.8"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path d="M60 6 C104 22 108 78 74 110 C52 132 42 120 46 100 C50 84 70 84 72 66 C74 46 52 34 30 46" />
    <path d="M60 24 C88 38 90 78 66 100 C54 110 50 100 54 90 C58 80 72 78 72 64" strokeOpacity="0.7" />
    <circle cx="62" cy="60" r="6" strokeOpacity="0.8" />
    <path d="M20 60 C30 66 30 78 22 86" strokeOpacity="0.6" />
    <path d="M14 74 C24 80 24 92 16 100" strokeOpacity="0.5" />
  </svg>
);

export const Divider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-4 text-gold ${className}`}>
    <span className="h-px w-16 bg-gold/40" />
    <svg viewBox="0 0 40 40" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1">
      <path d="M20 3 C26 12 26 18 20 26 C14 18 14 12 20 3 Z" />
      <circle cx="20" cy="30" r="3" />
    </svg>
    <span className="h-px w-16 bg-gold/40" />
  </div>
);


// Stylized henna hand (kına eli) with paisley palm decoration
export const HennaHand = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 120 150"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {/* palm + wrist */}
    <path d="M38 148 C34 120 33 108 34 96 C24 92 20 80 22 70 C23 64 28 63 31 68 C33 72 34 78 36 82 C35 66 35 46 37 40 C38 34 45 34 46 41 C47 50 46 66 47 74 C48 60 49 40 52 34 C53 29 60 29 61 35 C62 44 60 64 60 74 C62 58 64 42 67 37 C69 32 75 33 75 40 C75 52 71 68 70 78 C73 66 78 56 82 54 C87 51 91 57 87 64 C82 74 74 84 71 92 C73 106 74 122 72 148" strokeOpacity="0.75" />
    {/* palm paisley */}
    <path d="M52 104 C60 96 66 100 64 108 C62 114 54 114 54 106 C54 100 60 100 60 104" strokeOpacity="0.6" />
    <circle cx="54" cy="118" r="3" strokeOpacity="0.6" />
    <path d="M44 120 C48 116 52 118 51 122" strokeOpacity="0.5" />
    <path d="M40 100 C44 96 49 98 48 103" strokeOpacity="0.5" />
    {/* fingertip dots */}
    <circle cx="36" cy="66" r="1.6" strokeOpacity="0.7" />
    <circle cx="46" cy="60" r="1.6" strokeOpacity="0.7" />
    <circle cx="60" cy="58" r="1.6" strokeOpacity="0.7" />
    <circle cx="70" cy="62" r="1.6" strokeOpacity="0.7" />
  </svg>
);

// Flowing henna vine used as a section accent
export const Vine = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 400 40"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path d="M0 20 C40 4 60 4 80 20 C100 36 120 36 140 20 C160 4 180 4 200 20 C220 36 240 36 260 20 C280 4 300 4 320 20 C340 36 360 36 400 20" strokeOpacity="0.6" />
    {[40, 120, 200, 280, 360].map((x) => (
      <g key={x}>
        <path d={`M${x} 12 C${x + 8} 6 ${x + 8} 16 ${x} 20 C${x - 8} 16 ${x - 8} 6 ${x} 12 Z`} strokeOpacity="0.5" />
        <circle cx={x} cy="24" r="1.4" strokeOpacity="0.7" />
      </g>
    ))}
  </svg>
);

// Corner flourish ornament
export const Corner = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 120 120"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path d="M4 4 C4 40 20 56 56 56" strokeOpacity="0.55" />
    <path d="M4 4 C40 4 56 20 56 56" strokeOpacity="0.55" />
    <path d="M14 14 C34 34 34 34 44 44" strokeOpacity="0.4" />
    <path d="M8 30 C18 26 26 30 24 40 C22 47 13 46 14 38" strokeOpacity="0.5" />
    <path d="M30 8 C26 18 30 26 40 24 C47 22 46 13 38 14" strokeOpacity="0.5" />
    <circle cx="60" cy="60" r="2" strokeOpacity="0.7" />
  </svg>
);
